export enum AirWaybillCarrierType {
  Courier,
  FreightForwarder,
}
